var map = {
	"./arrow-bottom.svg": "ae00",
	"./arrow-close.svg": "4130",
	"./arrow-left.svg": "ac3b",
	"./arrow-long-left.svg": "f0ad",
	"./arrow-right.svg": "cd8c",
	"./arrow-top-right.svg": "b3f8",
	"./arrow-top.svg": "d162",
	"./burger.svg": "ada2",
	"./cart.svg": "daca",
	"./circle-cross.svg": "bce9",
	"./close.svg": "8b1b",
	"./cogwheel.svg": "f0fe",
	"./cross.svg": "2ad7",
	"./danger.svg": "f6f2",
	"./edit.svg": "daf0",
	"./eye.svg": "7364",
	"./flush.svg": "dd27",
	"./icon-menu-burger.svg": "57d5",
	"./icon-menu-filters.svg": "070a",
	"./letter.svg": "7c5d",
	"./loader.svg": "04ff",
	"./logout.svg": "69e3",
	"./logs.svg": "50ac",
	"./mail-open.svg": "07f9",
	"./qrcode.svg": "8b10",
	"./search.svg": "d103",
	"./send.svg": "5b6e",
	"./settings.svg": "9174",
	"./trash.svg": "af22",
	"./users.svg": "d956",
	"./warning.svg": "daa9",
	"./world.svg": "0257"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";